import React, {useState} from 'react';
import style from './style.module.css'
import { Link } from 'react-router-dom';

import Icons from '../Icons/Icons';
import { faSpinner, faBook, faSquareCheck, faBan, faCircleHalfStroke, faLock } from '@fortawesome/free-solid-svg-icons';

import { inProgress, unavailable, ModuleItem, urlAcademy, locked } from '../../utils/constants';

interface ChapterItemProps {
    chapter: string,
    status: string,
    available: boolean,
    description: string,
    modules: ModuleItem[],
    language: string
}

const ChapterItem: React.FC<ChapterItemProps> = ({chapter,status,available,description,modules,language}) => {

    const [chapterOpen,setChapterOpen] = useState(false);

    const handleOpenChapter = () => {
        if(chapterOpen){
            setChapterOpen(false);
            return;
        }
        setChapterOpen(true);
    }

    let progressIcons = {
        'in_progress' : <div className={style.inProgress}><Icons icon={faCircleHalfStroke} /></div>, 
        'complete' : <div className={style.complete}><Icons icon={faSquareCheck} /></div>,
        'unavailable' : <div className={style.unavailable}><Icons icon={faBan} /></div>,
        'locked' : <div className={style.locked}><Icons icon={faLock} /></div>
    };

    return (<>
        <div className={`${style.chapter} ${available ? style.available : style.unavailable}`}>
            <div className={`${style.title} ${chapterOpen ? style.open : ''}`} onClick={handleOpenChapter}>
                <Icons icon={faBook} /><span>{chapter}</span><div className={style.status}>
                    {
                        status === inProgress ? 
                            <div className={style.inProgress}>
                                <Icons icon={faCircleHalfStroke} />
                            </div> :
                        status === unavailable ?
                            <div className={style.unavailable}>
                                <Icons icon={faBan} />
                            </div> :
                        status === locked ?
                            <div className={style.locked}>
                                <Icons icon={faLock} />
                            </div>
                            :
                            <div className={style.complete}>
                                <Icons icon={faSquareCheck} />
                            </div>
                    }
                </div>
            </div>
            <div className={style.description}>{description}</div>
            <div className={`${style.progressWrap} ${chapterOpen ? style.open : ''}`}>
                {
                    modules.map((item) => (
                        <div className={`${style.progress} ${item.status === unavailable ? style.hidden : ''}`} key={item.status}>
                            {
                                item.status === unavailable ?
                                    <>{progressIcons[item.status]}<span>{item.label[language]}</span></> 
                                :
                                    <Link to={urlAcademy+item.link}>{progressIcons[item.status]}<span>{item.label[language]}</span></Link>
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    </>)
}

export default ChapterItem;